module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loader) ? _c('div', {
    staticClass: "loader-container"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-image"
  }, [_c('img', {
    attrs: {
      "src": require("@/common/assets/img/loader.svg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-536eb19e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/loader.vue
// module id = 641
// module chunks = 1